
type BalanceCardProps = {
  formattedBalance: string;
  availableQndt?: number;
  isVerified?: boolean;
  canDeposit: boolean;
  canWithdraw: boolean;
  canQndt: boolean;
  onDeposit: () => void;
  onWithdraw: () => void;
  onQndtTransfer: () => void;
};

export function BalanceCard({
  formattedBalance,
  availableQndt = 0,
  isVerified = true,
  canDeposit,
  canWithdraw,
  // canQndt,
  onDeposit,
  onWithdraw,
  onQndtTransfer,
}: BalanceCardProps) {
  // const qndtDisabled = !isVerified || availableQndt <= 0;
  const qndtDisabled = true;
  const qndtTitle = !isVerified
    ? 'Your account is not verified yet'
    : availableQndt <= 0
      ? 'No QNDT available to transfer'
      : 'Transfer QNDT to another user';

  const withdrawDisabled = !isVerified;
  const withdrawTitle = !isVerified
    ? 'Your account is not verified yet'
    : 'Withdraw funds';

  const depositTitle = !isVerified
    ? 'Your account is not verified yet'
    : 'Add funds to wallet';

  return (
    <div className="mb-5 rounded-xl border border-[var(--dash-line)] bg-white p-5 sm:p-6">
      <p className="text-xs font-medium uppercase tracking-wider text-[var(--dash-muted)]">
        Available balance
      </p>
      <p className="mt-2 text-3xl font-bold tracking-tight text-[var(--dash-ink)] sm:text-4xl">
        {formattedBalance}
      </p>
      {!isVerified ? (
        <p
          className="mt-3 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-left text-xs font-medium text-amber-900"
          role="status"
        >
          Your account is not verified. Please contact to the admin for verification.  
        </p>
      ) : null}
      <div className="mt-4 flex flex-wrap gap-2">
        {canDeposit ? (
          <button
            type="button"
            onClick={onDeposit}
            disabled={!isVerified}
            title={depositTitle}
            className="rounded-lg px-4 py-2 text-sm font-semibold text-white disabled:cursor-not-allowed disabled:opacity-50"
            style={{ background: 'var(--dash-brand, #003481)' }}
          >
            Deposit
          </button>
        ) : null}
        {canWithdraw ? (
          <button
            type="button"
            onClick={onWithdraw}
            disabled={withdrawDisabled}
            title={withdrawTitle}
            className="rounded-lg border border-[var(--dash-line)] px-4 py-2 text-sm font-semibold text-[var(--dash-ink)] hover:bg-[var(--dash-soft)] disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:bg-transparent"
          >
            Withdraw
          </button>
        ) : null}
        {/* {canQndt ? ( */}
          <button
            type="button"
            onClick={onQndtTransfer}
            disabled={qndtDisabled}
            title={qndtTitle}
            className="rounded-lg border border-[var(--dash-line)] px-4 py-2 text-sm font-semibold text-[var(--dash-ink)] hover:bg-[var(--dash-soft)] disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:bg-transparent"
          >
            QNDT Transfer
          </button>
        {/* ) : null} */}
      </div>
    </div>
  );
}
